export const multiplePhaseTabs = [
  { name: 'Phases', link: 'phases' },
  { name: 'Basic Info', link: 'basic-info' },
  //  TODO: reuse after implementation
  // { name: 'Reports', link: 'reports' },
  // { name: 'Analytics', link: 'analytics' },
];
